import { FunctionComponent } from 'react';

export const ResizeableStyles: FunctionComponent<
  React.PropsWithChildren<unknown>
> = () => {
  return (
    <style type="text/css">{`
  .react-resizable {
    position: relative;
    background-clip: padding-box;
    /* disable unintended text highlight when quickly resizing column widths */
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
  }

  .react-resizable-handle {
    position: absolute;
    width: 10px;
    height: 100%;
    bottom: 0;
    right: -5px;
    cursor: col-resize;
    z-index: 1;
  }

  `}</style>
  );
};
